///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const ErrorIcon = ({
  height,
  fill,
  title = messages.error.defaultMessage,
  width,
  ...rest
}) => (
  <svg
    aria-labelledby="error-icon"
    width={width}
    height={height}
    viewBox="0 0 38 32"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <title id="error-icon">{title}</title>
    <path
      d="M20,9.98333333 L32.55,31.6666667 L7.45,31.6666667 L20,9.98333333 M20,3.33333333 L1.66666667,35 L38.3333333,35 L20,3.33333333 Z M21.6666667,26.6666667 L18.3333333,26.6666667 L18.3333333,30 L21.6666667,30 L21.6666667,26.6666667 Z M21.6666667,16.6666667 L18.3333333,16.6666667 L18.3333333,23.3333333 L21.6666667,23.3333333 L21.6666667,16.6666667 Z"
      fill={fill}
    />
  </svg>
);

export default ErrorIcon;
